import { Color } from '@/GlobalStyles';

export default {
  tempsLecture: {
    distance: 0.4,
  },
  tempsTablette: {
    distance: 0.5,
  },
  tempsSmartphone: {
    distance: 0.35,
  },
  tempsAutreVisionPres: {
    distance: 0.4,
  },
  tempsDiscussion: {
    distance: 1.5,
  },
  tempsJeuxSociete: {
    distance: 0.8,
  },
  tempsOrdinateur: {
    distance: 0.6,
  },
  tempsCuisine: {
    distance: 0.6,
  },
  tempsConduite: {
    distance: 50,
  },
  tempsTelevision: {
    distance: 3.5,
  },
};

export const defocusAbsisse = [2, 1.5, 1, 0.5, 0, -0.5, -1, -1.5, -2, -2.5, -3, -3.5, -4];
